<app-confirm-dialog
  [title]="'ERROR.LAZY_LOADING_ERROR.TITLE' | translate"
  [labelConfirm]="'ACTIONS.RELOAD' | translate"
  [confirmAction]="doReload"
>
  {{ 'ERROR.LAZY_LOADING_ERROR.DETAIL' | translate }}
</app-confirm-dialog>
